if (!window.WdUpsale) {
    class WdUpsale {
        /** @type {NodeListOf<HTMLInputElement>} */
        upsaleInputs;

        constructor() {
            this.upsaleInputs = document.querySelectorAll(`[name="wd-upsale"]`);
            document.addEventListener('product-form:submitted', () => {
                this.resetUpsaleInputs();
            }, { once: true });
        }

        getSelectedUpsaleProducts() {
            return Array.from(this.upsaleInputs).filter(input => input.checked).map(input => input.value);
        }

        disabledUpsaleInputs() {
            this.upsaleInputs.forEach(input => {
                input.disabled = true;
                if (input.checked)
                    input.closest('.wd-upsale__toggle')?.classList.add('btn--loading');
            });
        }

        resetUpsaleInputs() {
            this.upsaleInputs.forEach(input => {
                input.checked = false;
                input.closest('.wd-upsale__toggle')?.classList.remove('btn--loading');
                input.disabled = false;
            });
        }
    }

    window.WdUpsale = WdUpsale;
}